import { defineNuxtRouteMiddleware } from '#app'
import { useProfileStore } from '~/stores/profileState'

export default defineNuxtRouteMiddleware(async (to) => {
  // Public routes never need a complete profile. This used to be a local list
  // that omitted /blog and /blog/**, so every blog request paid for a session
  // lookup plus a `profiles` query before rendering.
  if (to.path === '/profile' || to.matched.length === 0 || isPublicPath(to.path)) {
    return
  }

  const supabase = useSupabaseClient()
  const { data: { session } } = await supabase.auth.getSession()
  const profileStore = useProfileStore()

  // Pokud uživatel není přihlášen, nemusíme nic kontrolovat
  if (!session) {
    profileStore.setProfileIncomplete(false)
    return
  }

  // Kontrola, zda má uživatel vyplněný profil
  try {
    const { data: profileData, error } = await supabase
      .from('profiles')
      .select('full_name')
      .eq('id', session.user.id)
      .single()

    // Pokud došlo k chybě nebo profil neexistuje nebo jméno není vyplněno
    if (error || !profileData || !profileData.full_name) {
      console.log('Uživatel nemá kompletní profil, přesměrování na /profile')

      // Uložíme informaci o neúplném profilu do store
      profileStore.setProfileIncomplete(true)

      // Uložíme původní URL, kam uživatel chtěl jít, abychom ho pak mohli přesměrovat zpět.
      // The import.meta.client guard is load-bearing: this middleware also runs on
      // the server, where `localStorage` is undefined and this line threw a
      // ReferenceError -> HTTP 500 for any logged-in user with an incomplete profile.
      const returnPath = to.fullPath
      if (import.meta.client && returnPath !== '/profile') {
        localStorage.setItem('returnPath', returnPath)
      }

      return navigateTo('/profile')
    } else {
      // Profil je vyplněn, můžeme pokračovat
      profileStore.setProfileIncomplete(false)
      return
    }
  } catch (error) {
    console.error('Chyba při kontrole profilu:', error)
    // V případě chyby necháme uživatele pokračovat
    return
  }
})
